(function () {
  if (window.__motuParallaxInit) return;
  window.__motuParallaxInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var nodes = document.querySelectorAll('[data-motu-parallax]');
    if (!nodes.length) return;

    nodes.forEach(function (el) {
      if (el.__motuParallaxBound) return;
      el.__motuParallaxBound = true;

      if (reduced) {
        el.classList.add('is-loaded', 'is-parallax-ready');
        return;
      }

      var maxOffset = parseFloat(el.getAttribute('data-motu-parallax-max')) || 60;
      var axisAttr = (el.getAttribute('data-motu-parallax-axis') || 'y').toLowerCase();
      var axes = axisAttr.split(',').map(function (s) { return s.trim(); });
      var hasX = axes.indexOf('x') !== -1;
      var hasY = axes.indexOf('y') !== -1 || (!hasX && axes.indexOf('x') === -1);
      var ticking = false;

      function update() {
        var rect = el.getBoundingClientRect();
        var viewportH = window.innerHeight || document.documentElement.clientHeight;
        var viewportW = window.innerWidth || document.documentElement.clientWidth;
        var progress = 1 - (rect.bottom / (viewportH + rect.height));
        if (progress < 0) progress = 0;
        else if (progress > 1) progress = 1;
        if (hasX) {
          var p = progress * 2;
          if (p > 1) p = 1;
          var dist = viewportW * 0.25;
          el.style.setProperty('--motu-parallax-x-left', (p * dist).toFixed(2) + 'px');
          el.style.setProperty('--motu-parallax-x-right', (-p * dist).toFixed(2) + 'px');
        }
        if (hasY) {
          var shift = (progress - 0.5) * 2 * maxOffset;
          el.style.setProperty('--motu-parallax-y', shift.toFixed(2) + 'px');
        }
        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      requestAnimationFrame(function () {
        el.classList.add('is-loaded');
        setTimeout(function () {
          el.classList.add('is-parallax-ready');
        }, 950);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
